import { css } from '@emotion/react';
import { Mapping } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/mapping.pb';
import { theme } from '@frontend/theme';
import { Chip } from '@frontend/design-system';
import { GenericChipsList } from '../generic-chip-list';

export const ProvidersChip = ({
  appointmentTypeId,
  mappingList,
  className,
}: {
  appointmentTypeId: string;
  mappingList: Mapping[];
  className?: string;
}) => {
  const providerNameList = mappingList
    .filter(
      (item) =>
        item.appointmentTypeMetaData?.id === appointmentTypeId &&
        !!item.providerMetaData?.id &&
        !!item.providerMetaData.name
    )
    .map((item) => ({ name: item.providerMetaData?.name ?? '' }));

  if (providerNameList.length === 0) return '-';

  return (
    <GenericChipsList
      items={providerNameList}
      renderChip={({ name }) => (
        <Chip key={name} variant='neutral' css={{ maxWidth: 100 }}>
          {name}
        </Chip>
      )}
      css={css`
        display: flex;
        flex-wrap: wrap;
        gap: ${theme.spacing(0.5)};
      `}
      className={className}
    />
  );
};
